// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import 'viewerjs/dist/viewer.css'
import './theme/index.less'
import Modal from './components/Modal/Modal'
import Viewer from 'v-viewer'

import './utils/http'
import { Toast } from 'vant'
import { Dialog } from 'vant';
import { Switch } from 'vant';
import { Loading } from 'vant';
import { Sku } from 'vant';
// import Vconsole from 'vconsole';
// let vConsole = new Vconsole();
// export default vConsole
// Vue.use(vConsole)
import { Sidebar, SidebarItem } from 'vant';
import Title from "@/components/Title.vue";

Vue.use(Title);
Vue.use(Sidebar);
Vue.use(SidebarItem);
Vue.use(Sku);
Vue.use(Loading);
Vue.use(Viewer)
Vue.use(Modal)
Vue.use(Toast)
Vue.use(Dialog)
Vue.use(Switch)
Vue.use(Loading);

Viewer.setDefaults({
  Options: {
    'inline': true,
    'button': true,
    'navbar': false,
    'title': false,
    'toolbar': false,
    'tooltip': false,
    'movable': false,
    'zoomable': false,
    'rotatable': false,
    'scalable': false,
    'transition': true,
    'fullscreen': true,
    'keyboard': true,
    'url': 'data-source'
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  mounted() {
    // 移除全局loading
    const globalLoading = document.getElementById('global-loading');
    if (globalLoading) globalLoading.parentNode.removeChild(globalLoading);
  },
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js